<ngx-loading [show]="loading"></ngx-loading>
<div class='col-md-12 col-sm-12 col-xs-12' *ngIf="slug_status == true">
  <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-12 reviewbottom">
    <div class="col-md-12 col-col-sm-12 col-xs-12 thankyoureview">
      <span><img [src]="business_logo" class="img-responsive" *ngIf="business_logo != null">
        <span class="bus_name_review">{{business_name}}</span>
      </span>
    </div>
    <!-- <button type="button" (click)="optinBtn()" class="btn btn-secondary btn-sm reviwadd">Yes</button> -->
    <!-- <li>
                <a (click)="optinBtn('no')" title="No" class="btn btn-sm px-3 discard-btn">No</a>
            </li> -->
    <!-- <ng-container *ngIf="optin_status != 'OPTOUT'">
      <div class="col-md-12 col-col-sm-12 col-xs-12 text-center" *ngIf="newwhatsappnumber == false">
        <p> Click <b>Opt-Out</b> to stop receiving WhatsApp communications from <b>{{business_name}}</b></p>

        <ul class="emojis">
          <li>
            <a (click)="optinBtn('yes')" class="btn btn-secondary btn-sm reviwadd mr-2" title="Yes">Opt-Out</a>
          </li>

        </ul>
        <ng-container *ngIf="newwhatsappnumber2 == true">
          <p style="color: #4a4a4a;">You have <b>opted out</b> to receive Whatsapp communication from
            <b>{{business_name}}</b></p>
        </ng-container>

      </div>
    </ng-container> -->
    <ng-container *ngIf="optInMedium">
      <div class="col-md-12 col-col-sm-12 col-xs-12 text-center">
        <p *ngIf="optInMedium">
          Click <b>Opt-Out</b> to stop receiving <b>{{slugMedium}}</b> communication from <b>{{business_name}}</b></p>

          <ul class="emojis">
          <li *ngFor="let opt of optin_list;">
            <a *ngIf="opt.status == 'Opt In' && slugMedium == opt.optin_medium.toLowerCase()" style="text-decoration: underline; color: #5c6bc0;" (click)="optIn(opt.optin_medium)"
              class="reviwadd mr-2" >Opt-Out from
              {{opt.optin_medium}}</a>
          </li>
        </ul>
        <!-- <ng-container *ngIf="newwhatsappnumber2 == true">
          <p style="color: #4a4a4a;">You have <b>opted out</b> to receive Whatsapp communication from
            <b>{{business_name}}</b></p>
        </ng-container> -->

      </div>
    </ng-container>
    <ng-container *ngIf="!optInMedium">
      <p style="color: #4a4a4a;text-align: center;">You will no longer receive <b>{{slugMedium}}</b> communication from
        <b>{{business_name}}</b></p>
    </ng-container>
  </div>
</div>
<footer *ngIf="slug_status == true">
  <div class="col-md-12 col-col-sm-12 col-xs-12">
    <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 thankyoureviewfooter">
      <p>Powered by</p>
      <a href="https://www.zceppa.com/?utm_source=zceppa&utm_medium=consumer_link&utm_campaign=optout" target="_blank">
        <img src="assets/images/zceppadark.svg" class="img-responsive">
      </a>
    </div>
  </div>
</footer>

<div class="container h-100 expiresec" *ngIf="slug_status == false">
  <div class="row align-items-center h-100 expiresec">
    <div class="col-6 mx-auto">
      <div class="expiretext text-center">
        <h2 class="pb-3">OOPS!</h2>
        <img src="assets/gifs/exclamation-mark.png" width="80px">
        <p class="pt-3">The link has either not found or expired</p>
      </div>
    </div>
  </div>
  <footer *ngIf="review_status == true">
    <div class="col-md-12 col-col-sm-12 col-xs-12">
      <div class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 thankyoureviewfooter">
        <p>Powered by</p>
        <a href="https://www.zceppa.com/?utm_source=zceppa&utm_medium=consumer_link&utm_campaign=optout" target="_blank">
          <img src="assets/images/zceppadark.svg" class="img-responsive">
        </a>
      </div>
    </div>
  </footer>
</div>
